<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/info-icon.svg" alt="">
    </div>
    Gráficos y Estadísticas
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Historial de envases</h2>
    <a routerLink="/container-report" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <h3 class="text-primary-700 text-xl">{{ reportDetail.header.container.containerType.name }} #{{ reportDetail.header.container.nroSerie }}</h3>

    <table class="table table-report-info w-full mb-4 hidden md:table text-sm">
      <tr>
        <th>Propietario:</th>
        <td>{{ reportDetail.header.container.containerOwner?.name || 'Sin Propietario' }}</td>
        <th>Cliente:</th>
        <td>{{ reportDetail.header.container.client.razonSocial }}</td>
      </tr>
      <tr>
        <th>Estado:</th>
        <td>{{ reportDetail.header.status }}</td>
        <th>Fecha de mantención:</th>
        <td *ngIf="reportDetail.maintenancesHistory && reportDetail.maintenancesHistory.length > 0">
          {{ reportDetail.maintenancesHistory[reportDetail.maintenancesHistory.length - 1].date | date:'dd-MM-yyyy' }}
        </td>
        <td *ngIf="!reportDetail.maintenancesHistory || reportDetail.maintenancesHistory.length === 0">
          No hay datos disponibles
        </td>        
      </tr>
      <tr>
        <th>Tara:</th>
        <td>{{ reportDetail.header.tara }}</td>
        <th>Fecha última PH:</th>
        <td *ngIf="reportDetail.header.lastPH && reportDetail.header.lastPH.length > 0">
          {{ reportDetail.header.lastPH | date:'dd-MM-yyyy' }}
        </td>
      </tr>
    </table>

    <table class="table table-report-info w-full mb-4 md:hidden">
      <tr>
        <th>Propietario:</th>
        <td>{{ reportDetail.header.container.containerOwner?.name || 'Sin Propietario' }}</td>
      </tr>
      <tr>
        <th>Cliente:</th>
        <td>{{ reportDetail.header.container.client.razonSocial }}</td>
      </tr>
      <tr>
        <th>Estado:</th>
        <td>{{ reportDetail.header.status }}</td>
      </tr>
      <tr>
        <th>Fecha de mantención:</th>
        <td *ngIf="reportDetail.maintenancesHistory && reportDetail.maintenancesHistory.length > 0">
          {{ reportDetail.maintenancesHistory[reportDetail.maintenancesHistory.length - 1].date | date:'dd-MM-yyyy' }}
        </td>
        <td *ngIf="!reportDetail.maintenancesHistory || reportDetail.maintenancesHistory.length === 0">
          No hay datos disponibles
        </td>        
      </tr>
      <tr>
        <th>Tara:</th>
        <td>{{ reportDetail.header.tara }}</td>
      </tr>
      <tr>
        <th>Fecha última PH:</th>
        <td *ngIf="reportDetail.header.lastPH && reportDetail.header.lastPH.length > 0">
          {{ reportDetail.header.lastPH | date:'dd-MM-yyyy' }}
        </td>
      </tr>
    </table>
    
    <div class="mb-4">
      <h3 class="text-lg text-primary-500">Historial de mantenciones</h3>
      <ul *ngFor="let maintenance of reportDetail.maintenancesHistory" class="list-report mb-2">
        <li>
          <span>{{ maintenance.name }} - {{ maintenance.date | date:'dd-MM-yyyy' }}</span>
          <button class="button button-outlined-primary" [routerLink]="['/container-report-detail', maintenance.id]">Ver más</button>
        </li>
      </ul>
    </div>
    
    <div class="mb-4">
      <h3 class="text-lg text-primary-500">Historial de Tara</h3>
      <table class="table table-report min-w-full">
        <thead>
          <tr>
            <th>Tara Inicial</th>
            <th>Tara Actual</th>
            <th>% Variación</th>
            <th>Estado</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tara of reportDetail.taraHistory">
            <td>{{ tara.taraInicial }}</td>
            <td>{{ tara.taraActual }}</td>
            <td></td>
            <td>{{ tara.estado }}</td>
            <td>{{ tara.fecha | date:'dd-MM-yyyy' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mb-4">
      <h3 class="text-lg text-primary-500">Historial de PH</h3>
      <table class="table table-report min-w-full">
        <thead>
          <tr>
            <th>N° Certificado PH</th>
            <th>Estado</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ph of reportDetail.phHistory">
            <td>{{ ph.certificadoIdiem }}</td>
            <td>{{ ph.estado }}</td>
            <td>{{ ph.fecha | date:'dd-MM-yyyy' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mb-4">
      <h3 class="text-lg text-primary-500">Historial de Granallado y Pintado</h3>
      <table class="table table-report min-w-full">
        <thead>
          <tr>
            <th>N° Certificado</th>
            <th>Estado</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let gp of reportDetail.gpHistory">
            <td>{{ gp.numCertificado }}</td>
            <td>{{ gp.estado }}</td>
            <td>{{ gp.fecha | date:'dd-MM-yyyy' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="flex justify-center mt-4">
      <button class="button button-danger" (click)="exportPdf()">Exportar PDF</button>
    </div>
    
  </div>
</div>
